// alerts/components/ScheduleRemainderAlert.jsx
import React from "react";
import { Link } from 'react-router-dom';
import BasicMessage from "./BasicMessage";

const ScheduleReminderAlert = ({ apiResponse, title }) => {
  const { status } = apiResponse;
  const { message, linkMessage } = apiResponse?.response ?? {};

  return (
    <BasicMessage title={title || "Device scan reminder"} status={status}>
      <span style={{ display: "flex", alignItems: "center", gap: "0.3rem", fontSize: "14px" }}>
        <span>{message}</span>
        <Link
          to="/app/inventory/settings/schedule-scan"
          style={{ color: "#0077FF", textDecoration: "underline" }}
        >
          {linkMessage}
        </Link>
      </span>
    </BasicMessage>
  );
};

export default ScheduleReminderAlert;
